export const DISCOUNT_ENCOURAGEMENT_THRESHOLD = 14;
